/**
 * Parse "lat, lon" (or "lat lon") from free text, validating ranges.
 *
 * Typing coordinates by hand is the fallback for everything OSM name search misses — a specific
 * hotel, a trailhead, a chateau — and a pasted Google Maps coordinate pair works directly.
 *
 * Returns `null` for both unparseable and out-of-range input, so callers that care about the
 * difference must check for empty input themselves before calling.
 *
 * Ruta has its own copy in `Ruta/src/lib/excursions.ts` — it's a separate build with no path
 * into this directory, so the duplication is deliberate. Keep the two regexes in step.
 */
export function parseCoords(text: string): { lat: number; lon: number } | null {
  const m = text.trim().match(/^(-?\d+(?:\.\d+)?)\s*[, ]\s*(-?\d+(?:\.\d+)?)$/);
  if (!m) return null;
  const lat = parseFloat(m[1]);
  const lon = parseFloat(m[2]);
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return null;
  return { lat, lon };
}
